import { defineStore } from 'pinia'

export const useUIStore = defineStore('ui', {
  persist: {
    enabled: true,
  },
  state: () => {
    return {
      collapsed: ['attributes.seller'],
    }
  },
})
